
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line

/**
 * SocialTradingAccountType enum
 */
class SocialTradingAccountType {
  /**
   * Initialize enum with a given value
   * @param {SocialTradingAccountType|number|Int64|UInt64=} value Enum value, defaults is 0
   * @constructor
   */
  constructor (value = 0) {
    if (value instanceof SocialTradingAccountType) {
      this.value = value.value
    } else {
      this.value = value
    }
  }

  /**
   * Is this enum equal to other one?
   * @this {!SocialTradingAccountType}
   * @param {!SocialTradingAccountType} other Other enum
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SocialTradingAccountType)) {
      throw new TypeError('Instance of SocialTradingAccountType is required!')
    }
    return this.value === other.value
  }

  /**
   * Get enum value
   * @this {!SocialTradingAccountType}
   * @returns {!number|!Int64|!UInt64} Enum value
   */
  valueOf () {
    return this.value
  }

  /**
   * Convert enum to string
   * @this {!SocialTradingAccountType}
   * @returns {!string} Enum value string
   */
  toString () {
    if (this.value === SocialTradingAccountType.REGULAR.value) {
      return 'REGULAR'
    }
    if (this.value === SocialTradingAccountType.MASTER.value) {
      return 'MASTER'
    }
    if (this.value === SocialTradingAccountType.INVESTOR.value) {
      return 'INVESTOR'
    }
    return '<unknown>'
  }

  /**
   * Inspect enum
   * @this {!SocialTradingAccountType}
   * @returns {!string} Enum value string
   */
  [util.inspect.custom] () {
    return this.toString()
  }

  /**
   * Convert enum to JSON
   * @this {!SocialTradingAccountType}
   * @returns {!number} Enum value for JSON
   */
  toJSON () {
    return this.value
  }

  /**
   * Create enum from object value
   * @param {!number} other Object value
   * @returns {!SocialTradingAccountType} Created enum
   */
  static fromObject (other) {
    return new SocialTradingAccountType(other)
  }
}

// noinspection PointlessArithmeticExpressionJS
SocialTradingAccountType.REGULAR = new SocialTradingAccountType(0 + 0)
// noinspection PointlessArithmeticExpressionJS
SocialTradingAccountType.MASTER = new SocialTradingAccountType(1 + 0)
// noinspection PointlessArithmeticExpressionJS
SocialTradingAccountType.INVESTOR = new SocialTradingAccountType(2 + 0)

export { SocialTradingAccountType };

/**
 * Fast Binary Encoding SocialTradingAccountType field model
 */
class FieldModelSocialTradingAccountType extends fbe.FieldModel {
  /**
   * Get the field size
   * @this {!FieldModelSocialTradingAccountType}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 1
  }

  /**
   * Get the value
   * @this {!FieldModelSocialTradingAccountType}
   * @param {SocialTradingAccountType=} defaults Default value, defaults is new SocialTradingAccountType()
   * @returns {!SocialTradingAccountType} Result value
   */
  get (defaults = new SocialTradingAccountType()) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return defaults
    }

    return new SocialTradingAccountType(this.readByte(this.fbeOffset))
  }

  /**
   * Set the value
   * @this {!FieldModelSocialTradingAccountType}
   * @param {!SocialTradingAccountType} value Value
   */
  set (value) {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return
    }

    this.writeByte(this.fbeOffset, value.value)
  }
}

export { FieldModelSocialTradingAccountType };
